import { useLayoutEffect } from 'react';

/**
 * W1-Hero / R2 — signal that the React booking app has mounted so the static
 * LCP-candidate H1 (rendered by apps/client/src/templates/bookingCoverme.hbs
 * when STATIC_H1_LCP=on) can either be hidden (legacy W1-Hero,
 * `body[data-react-mounted='1'] .cm-static-h1 { display:none }`) or morphed
 * in place (R2 CLS fix — swap class from `cm-static-h1` to
 * `cm-static-h1--react-mounted` so the same node transitions from the 128px
 * hero-style to the 32px form-page H1 style; the React-side H1 is then
 * hidden via `body[data-react-mounted='r2'] .trip-details-fields h1
 * { display:none }` also emitted in the hbs style block). Which path fires
 * is decided by the server — HBS adds `data-r2-cls-fix="on"` on the static
 * H1 only when COVERME_R2_CLS_FIX=on. Must live on the booking root so it
 * fires on every step (including the landing TravellerDetails), not only on
 * TripDetails. useLayoutEffect runs after commit but before the browser's
 * next paint, so the swap is synchronous — no double-H1 flash. No-op if
 * the static H1 was not emitted.
 */
export const useReactMountSignal = (): void => {
  useLayoutEffect(() => {
    if (typeof document === 'undefined' || !document.body) {
      return;
    }
    const staticH1 = document.querySelector<HTMLElement>('h1.cm-static-h1');
    if (staticH1?.dataset.r2ClsFix === 'on') {
      // R2 path — preserve the LCP paint, morph in place via class swap.
      staticH1.classList.add('cm-static-h1--react-mounted');
      document.body.dataset.reactMounted = 'r2';
    } else {
      // Legacy W1-Hero path — CSS rule hides the static H1 via body dataset.
      document.body.dataset.reactMounted = '1';
    }
  }, []);
};
